import React from 'react';
// Faz C (2026-09-03): Basim.js'ten satır aralığıyla BİREBİR taşındı — davranış değişmedi.

// Konu dağılım bar chart (C4)
function KonuDagilimChart({ konular, sayilari, toplam }) {
  const RENKLER = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316'];
  const veriler = konular.map((k, i) => ({
    konu: k, sayi: sayilari[k] || 0, renk: RENKLER[i % RENKLER.length],
  }));
  let offset = 0;
  return (
    <div>
      <div className="text-[10px] text-gray-500 mb-1 flex justify-between">
        <span>Konu Dağılımı</span>
        <span>Toplam: <strong>{toplam}</strong></span>
      </div>
      <svg viewBox="0 0 400 24" className="w-full h-6">
        {veriler.map((v) => {
          const w = (v.sayi / toplam) * 400;
          const x = offset;
          offset += w;
          return <rect key={v.konu} x={x} y={0} width={w} height={24} fill={v.renk} />;
        })}
      </svg>
      <div className="flex flex-wrap gap-1 mt-1.5">
        {veriler.map(v => (
          <div key={v.konu} className="flex items-center gap-1 text-[10px]">
            <span className="inline-block w-2.5 h-2.5 rounded" style={{ background: v.renk }} />
            <span className="text-gray-700">{v.konu}: <strong>{v.sayi}</strong></span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default KonuDagilimChart;
